export default "https://assets-v2.scaler.com/packs/files/galaxy watch.f2d117.webp";